import PropTypes from "prop-types";

export const VerificationListIcon = ({ active, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
      {...props}>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M14.259 1.758H7.592c-3.333 0-5 1.666-5 5V17.59c0 .458.375.833.834.833h10.833c3.333 0 5-1.666 5-5V6.758c0-3.334-1.667-5-5-5z"></path>
      <path
        stroke={active ? "#0071BC" : "#455A64"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.2"
        d="M6.76 8.008h8.333M6.76 12.174h5.833"></path>
    </svg>
  );
};

VerificationListIcon.propTypes = {
  active: PropTypes.bool
};
